// tslint:disable
export enum PharmacyType {
    /**
     * @description OTHER
     */
    OTHER = 0,
    /**
     * @description RETAIL
     */
    RETAIL = 1,
    /**
     * @description LABORATORY
     */
    LABORATORY = 2,
    /**
     * @description HOSPITAL
     */
    HOSPITAL = 3,
    /**
     * @description MANAGED CARE ORGINIZATION
     */
    MANAGEDCAREORGINIZATION = 4,
    /**
     * @description RESIDENTIAL TREATMENT
     */
    RESIDENTIALTREATMENT = 5,
}
